module.exports = __webpack_public_path__ + "static/media/5.4_preview.7425590b.png";